module.exports = __webpack_public_path__ + "static/media/angular.ef1abca2.png";